import { fromJS } from 'immutable'
import { canUseDOM } from '../lib/utils'
import { push } from 'react-router-redux'
import {
  addBlacklistCategory,
  addBlacklistSource,
  addSubscribeSource,
  addBlacklistTag,
  addUserFeed,
  addUserWordFilter,
  addUserSavedSearch,
  addWeatherLocation,
  addWhitelistCategory,
  addWhitelistTag,
  getUser,
  logoutAmpparitUser,
  removeBlacklistCategory,
  removeBlacklistSource,
  removeSubscribeSource,
  removeBlacklistTag,
  removeUserFeed,
  removeUserWordFilter,
  removeUserSavedSearch,
  removeWhitelistCategory,
  removeWhitelistTag,
  setDefaultWeatherLocation,
  setKeyValue,
  setUserVoteFilter,
  removeWeatherLocation,
  updateUserFeed,
} from '../api/api'
import { Cookies } from 'react-cookie'
import { config } from '../../config/config'
import {
  selectUserJWT,
  selectIsUserLoggedIn,
  selectUserLayoutWidth,
  selectUserActiveTheme,
  selectUserFrontPage,
  selectUserLastFetchTimestamp,
} from '../selectors/userSelector'
import { setThemeBodyClass } from '../lib/themes'
import { setLayoutWidthBodyClass } from '../lib/layout'
import { selectLocationPath, selectLocationStatus } from '../selectors/statusSelector'
import { logException, logWarning } from '../sentry'
import { isTimestampFresh } from '../lib/utils'
import { genericNotification } from '../components/notification/notificationActions'

export const SET_LOGGED_IN_USER = 'SET_LOGGED_IN_USER'

export const CLEAR_USER_JWT = 'CLEAR_USER_JWT'

export const FETCH_USER_PROFILE = 'FETCH_USER_PROFILE'
export const FETCH_USER_PROFILE_FAILURE = 'FETCH_USER_PROFILE_FAILURE'

export const WHITELIST_CATEGORY = 'WHITELIST_CATEGORY'
export const WHITELIST_CATEGORY_SUCCESS = 'WHITELIST_CATEGORY_SUCCESS'
export const WHITELIST_CATEGORY_FAILURE = 'WHITELIST_CATEGORY_FAILURE'

export const UNWHITELIST_CATEGORY = 'UNWHITELIST_CATEGORY'
export const UNWHITELIST_CATEGORY_SUCCESS = 'UNWHITELIST_CATEGORY_SUCCESS'
export const UNWHITELIST_CATEGORY_FAILURE = 'UNWHITELIST_CATEGORY_FAILURE'

export const BLACKLIST_CATEGORY = 'BLACKLIST_CATEGORY'
export const BLACKLIST_CATEGORY_SUCCESS = 'BLACKLIST_CATEGORY_SUCCESS'
export const BLACKLIST_CATEGORY_FAILURE = 'BLACKLIST_CATEGORY_FAILURE'

export const UNBLACKLIST_CATEGORY = 'UNBLACKLIST_CATEGORY'
export const UNBLACKLIST_CATEGORY_SUCCESS = 'UNBLACKLIST_CATEGORY_SUCCESS'
export const UNBLACKLIST_CATEGORY_FAILURE = 'UNBLACKLIST_CATEGORY_FAILURE'

export const TOGGLE_OVERLAY_OPEN = 'TOGGLE_OVERLAY_OPEN'

export const ADD_USER_WORD_FILTER = 'ADD_USER_WORD_FILTER'
export const ADD_USER_WORD_FILTER_SUCCESS = 'ADD_USER_WORD_FILTER_SUCCESS'
export const ADD_USER_WORD_FILTER_FAILURE = 'ADD_USER_WORD_FILTER_FAILURE'
export const ADD_USER_WORD_FILTER_MAX = 'ADD_USER_WORD_FILTER_MAX'

export const REMOVE_USER_WORD_FILTER = 'REMOVE_USER_WORD_FILTER'
export const REMOVE_USER_WORD_FILTER_SUCCESS = 'REMOVE_USER_WORD_FILTER_SUCCESS'
export const REMOVE_USER_WORD_FILTER_FAILURE = 'REMOVE_USER_WORD_FILTER_FAILURE'

export const ADD_USER_SAVED_SEARCH = 'ADD_USER_SAVED_SEARCH'
export const ADD_USER_SAVED_SEARCH_SUCCESS = 'ADD_USER_SAVED_SEARCH_SUCCESS'
export const ADD_USER_SAVED_SEARCH_FAILURE = 'ADD_USER_SAVED_SEARCH_FAILURE'
export const ADD_USER_SAVED_SEARCH_MAX = 'ADD_USER_SAVED_SEARCH_MAX'

export const REMOVE_USER_SAVED_SEARCH = 'REMOVE_USER_SAVED_SEARCH'
export const REMOVE_USER_SAVED_SEARCH_SUCCESS = 'REMOVE_USER_SAVED_SEARCH_SUCCESS'
export const REMOVE_USER_SAVED_SEARCH_FAILURE = 'REMOVE_USER_SAVED_SEARCH_FAILURE'

export const REMOVE_CUSTOM_FEED = 'REMOVE_CUSTOM_FEED'
export const REMOVE_CUSTOM_FEED_SUCCESS = 'REMOVE_CUSTOM_FEED_SUCCESS'
export const REMOVE_CUSTOM_FEED_FAILURE = 'REMOVE_CUSTOM_FEED_FAILURE'

export const ADD_CUSTOM_FEED = 'ADD_CUSTOM_FEED'
export const ADD_CUSTOM_FEED_SUCCESS = 'ADD_CUSTOM_FEED_SUCCESS'
export const ADD_CUSTOM_FEED_FAILURE = 'ADD_CUSTOM_FEED_FAILURE'

export const UPDATE_CUSTOM_FEED = 'UPDATE_CUSTOM_FEED'
export const UPDATE_CUSTOM_FEED_SUCCESS = 'UPDATE_CUSTOM_FEED_SUCCESS'
export const UPDATE_CUSTOM_FEED_FAILURE = 'UPDATE_CUSTOM_FEED_FAILURE'

export const SET_ACTIVE_USER_PROFILE = 'SET_ACTIVE_USER_PROFILE'

export const SET_NIGHT_MODE = 'SET_NIGHT_MODE'
export const SET_NIGHT_MODE_SUCCESS = 'SET_NIGHT_MODE_SUCCESS'
export const SET_NIGHT_MODE_FAILURE = 'SET_NIGHT_MODE_FAILURE'

export const WHITELIST_TAG = 'WHITELIST_TAG'
export const WHITELIST_TAG_SUCCESS = 'WHITELIST_TAG_SUCCESS'
export const WHITELIST_TAG_FAILURE = 'WHITELIST_TAG_FAILURE'

export const UNWHITELIST_TAG = 'UNWHITELIST_TAG'
export const UNWHITELIST_TAG_SUCCESS = 'UNWHITELIST_TAG_SUCCESS'
export const UNWHITELIST_TAG_FAILURE = 'UNWHITELIST_TAG_FAILURE'

export const BLACKLIST_TAG = 'BLACKLIST_TAG'
export const BLACKLIST_TAG_SUCCESS = 'BLACKLIST_TAG_SUCCESS'
export const BLACKLIST_TAG_FAILURE = 'BLACKLIST_TAG_FAILURE'

export const UNBLACKLIST_TAG = 'UNBLACKLIST_TAG'
export const UNBLACKLIST_TAG_SUCCESS = 'UNBLACKLIST_TAG_SUCCESS'
export const UNBLACKLIST_TAG_FAILURE = 'UNBLACKLIST_TAG_FAILURE'

export const BLACKLIST_SOURCE = 'BLACKLIST_SOURCE'
export const BLACKLIST_SOURCE_SUCCESS = 'BLACKLIST_SOURCE_SUCCESS'
export const BLACKLIST_SOURCE_FAILURE = 'BLACKLIST_SOURCE_FAILURE'
export const SOURCES_MIN_LIMIT = 'SOURCES_MIN_LIMIT'

export const UNBLACKLIST_SOURCE = 'UNBLACKLIST_SOURCE'
export const UNBLACKLIST_SOURCE_SUCCESS = 'UNBLACKLIST_SOURCE_SUCCESS'
export const UNBLACKLIST_SOURCE_FAILURE = 'UNBLACKLIST_SOURCE_FAILURE'

export const SUBSCRIBE_SOURCE = 'SUBSCRIBE_SOURCE'
export const SUBSCRIBE_SOURCE_SUCCESS = 'SUBSCRIBE_SOURCE_SUCCESS'
export const SUBSCRIBE_SOURCE_FAILURE = 'SUBSCRIBE_SOURCE_FAILURE'

export const UNSUBSCRIBE_SOURCE = 'UNSUBSCRIBE_SOURCE'
export const UNSUBSCRIBE_SOURCE_SUCCESS = 'UNSUBSCRIBE_SOURCE_SUCCESS'
export const UNSUBSCRIBE_SOURCE_FAILURE = 'UNSUBSCRIBE_SOURCE_FAILURE'

export const SET_VOTE_FILTER = 'SET_VOTE_FILTER'
export const SET_VOTE_FILTER_SUCCESS = 'SET_VOTE_FILTER_SUCCESS'
export const SET_VOTE_FILTER_FAILURE = 'SET_VOTE_FILTER_FAILURE'

export const LOGOUT_USER = 'LOGOUT_USER'
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS'
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE'

export const CHANGE_FRONT_PAGE = 'CHANGE_FRONT_PAGE'
export const CHANGE_FRONT_PAGE_SUCCESS = 'CHANGE_FRONT_PAGE_SUCCESS'
export const CHANGE_FRONT_PAGE_FAILURE = 'CHANGE_FRONT_PAGE_FAILURE'

export const CHANGE_THEME = 'CHANGE_THEME'
export const CHANGE_THEME_SUCCESS = 'CHANGE_THEME_SUCCESS'
export const CHANGE_THEME_FAILURE = 'CHANGE_THEME_FAILURE'

export const CHANGE_LAYOUT_WIDTH = 'CHANGE_LAYOUT_WIDTH'
export const CHANGE_LAYOUT_WIDTH_FAILURE = 'CHANGE_LAYOUT_WIDTH_FAILURE'
export const CHANGE_LAYOUT_WIDTH_SUCCESS = 'CHANGE_LAYOUT_WIDTH_SUCCESS'

export const LAYOUT_WIDTH_NORMAL = 'normal'
export const LAYOUT_WIDTH_WIDE = 'wide'
export const LAYOUT_WIDTH_FULL = 'full'

export const CHANGE_SHOW_CUSTOM_FEEDS_IN_SIDEBAR = 'CHANGE_SHOW_CUSTOM_FEEDS_IN_SIDEBAR'
export const CHANGE_SHOW_CUSTOM_FEEDS_IN_SIDEBAR_FAILURE = 'CHANGE_SHOW_CUSTOM_FEEDS_IN_SIDEBAR_FAILURE'
export const CHANGE_SHOW_CUSTOM_FEEDS_IN_SIDEBAR_SUCCESS = 'CHANGE_SHOW_CUSTOM_FEEDS_IN_SIDEBAR_SUCCESS'

export const REMOVE_WEATHER_LOCATION = 'REMOVE_WEATHER_LOCATION'
export const REMOVE_WEATHER_LOCATION_SUCCESS = 'REMOVE_WEATHER_LOCATION_SUCCESS'
export const REMOVE_WEATHER_LOCATION_FAILURE = 'REMOVE_WEATHER_LOCATION_FAILURE'

export const ADD_WEATHER_LOCATION = 'ADD_WEATHER_LOCATION'
export const ADD_WEATHER_LOCATION_SUCCESS = 'ADD_WEATHER_LOCATION_SUCCESS'
export const ADD_WEATHER_LOCATION_FAILURE = 'ADD_WEATHER_LOCATION_FAILURE'

export const SET_DEFAULT_WEATHER_LOCATION = 'SET_DEFAULT_WEATHER_LOCATION'
export const SET_DEFAULT_WEATHER_LOCATION_SUCCESS = 'SET_DEFAULT_WEATHER_LOCATION_SUCCESS'
export const SET_DEFAULT_WEATHER_LOCATION_FAILURE = 'SET_DEFAULT_WEATHER_LOCATION_FAILURE'

export const SET_TEMPORARY_PROFILE = 'SET_TEMPORARY_PROFILE'

export const SET_AB_TEST_BUCKET = 'SET_AB_TEST_BUCKET'

// Cookie names as constants to avoid typos
export const TEMP_PROFILE_COOKIE_NAME = 'tempProfile'
export const AMPPARIT_USER_COOKIE_NAME = 'ampUser'
export const AB_BUCKET_COOKIE_NAME = 'abBucket'

export const defaultTempProfile = fromJS({
  nightMode: false,
})



function getTempProfile(cookies) {
  const cookieProfile = cookies.get(TEMP_PROFILE_COOKIE_NAME)
  const tempProfile = Object.assign({}, defaultTempProfile.toJS(), cookieProfile)
  return tempProfile
}


/**
 * Get the A/B test bucket for the current user and persist it to cookie.
 * Returns an integer in [0, 99]. For logged-in users, bucket is derived
 * deterministically from almaIdHash. For logged-out users, bucket is read
 * from existing cookie or generated randomly if not present.
 */
export function getOrCreateAbBucket(cookies, almaIdHash) {
  if (typeof almaIdHash === 'string' && almaIdHash.match(/^[0-9a-fA-F]{8,}$/)) {
    const bucket = parseInt(almaIdHash.slice(0, 8), 16) % 100
    cookies.set(AB_BUCKET_COOKIE_NAME, String(bucket), config.cookieOptions)
    return bucket
  }
  const abCookie = cookies.get(AB_BUCKET_COOKIE_NAME)
  if (typeof abCookie === 'string' && abCookie.match(/^[0-9]{1,2}$/)) {
    return Number(abCookie)
  }
  const bucket = Math.floor(Math.random() * 100)
  cookies.set(AB_BUCKET_COOKIE_NAME, String(bucket), config.cookieOptions)
  return bucket
}


function setTempProfile(cookies, tempProfile) {
  return dispatch => {
    if (!tempProfile) {
      logWarning('profileData not provided, using default data. This should not happen.')
      tempProfile = defaultTempProfile.toJS()
    }

    dispatch({
      type: SET_TEMPORARY_PROFILE,
      profileData: tempProfile,
    })

    // Prune any obsolete data from existing tempProfile cookie
    for (const key in tempProfile) {
      if (!defaultTempProfile.has(key)) {
        delete tempProfile[key]
      }
    }
    cookies.set(TEMP_PROFILE_COOKIE_NAME, tempProfile, config.cookieOptions)
  }
}

/**
 * Sync redux state from logged in user's profile data from server. Call this to
 * make sure profile data in redux store is up to date. Note that all actions
 * that modify user profile automatically refresh the profile data.
 * @param {int} maxStaleSecs
 * @returns
 */
export function fetchUserProfile(maxStaleSecs = 0) {
  return (dispatch, getState) => {
    const state = getState()
    const lastFetchTimestamp = selectUserLastFetchTimestamp(state)
    if (isTimestampFresh(lastFetchTimestamp, maxStaleSecs) || !selectIsUserLoggedIn(state)) {
      return
    }

    dispatch({
      type: FETCH_USER_PROFILE,
    })

    const jwt = selectUserJWT(state)
    return getUser(jwt)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: FETCH_USER_PROFILE_FAILURE,
          timestamp: Date.now(),
          error,
        })
      })
  }
}



export function changeFrontPage(frontPage) {
  return (dispatch, getState) => {
    dispatch({
      type: CHANGE_FRONT_PAGE,
    })

    return setKeyValue('www-frontPage', frontPage)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: CHANGE_FRONT_PAGE_FAILURE,
          error,
        })
      })
  }
}

export function changeTheme(theme) {
  return (dispatch, getState) => {
    dispatch({
      type: CHANGE_THEME,
    })

    return setKeyValue('www-theme', theme)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: CHANGE_THEME_FAILURE,
          error,
        })
      })
  }
}

export function setNightMode(active) {
  return (dispatch, getState) => {

    active = !!active
    dispatch({
      type: SET_NIGHT_MODE,
      active,
    })

    const state = getState()
    if (!selectIsUserLoggedIn(state)) {
      const cookies = new Cookies()
      const tempProfile = getTempProfile(cookies)
      tempProfile.nightMode = active
      cookies.set(TEMP_PROFILE_COOKIE_NAME, tempProfile, config.cookieOptions)

      dispatch({
        type: SET_NIGHT_MODE_SUCCESS,
        active,
      })

      setThemeBodyClass(selectUserActiveTheme(getState()))

      return Promise.resolve()
    } else {
      return dispatch({
        type: SET_NIGHT_MODE_FAILURE,
      })
    }
  }
}

export function changeLayoutWidth(layoutWidth) {
  return dispatch => {
    dispatch({
      type: CHANGE_LAYOUT_WIDTH,
    })

    return setKeyValue('www-layoutWidth', layoutWidth)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: CHANGE_LAYOUT_WIDTH_FAILURE,
          error,
        })
      })
  }
}

export function setShowUserFeedsBoxInSidebar(show) {
  return dispatch => {
    dispatch({
      type: CHANGE_SHOW_CUSTOM_FEEDS_IN_SIDEBAR,
    })
    return setKeyValue('www-showUserFeedsBoxInSidebar', show)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: CHANGE_SHOW_CUSTOM_FEEDS_IN_SIDEBAR_FAILURE,
          error,
        })
      })
  }
}


export function blacklistSource(sourceId) {
  return (dispatch) => {
    dispatch({
      type: BLACKLIST_SOURCE,
      source: sourceId,
    })

    return addBlacklistSource(sourceId)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        if (error.response && error.response.status === 429) {
          return dispatch({
            type: SOURCES_MIN_LIMIT,
          })
        } else {
          logException(error)
          dispatch({
            type: BLACKLIST_SOURCE_FAILURE,
            source: sourceId,
            error,
          })
        }
      })
  }
}

export function unblacklistSource(sourceId) {
  return (dispatch) => {
    dispatch({
      type: UNBLACKLIST_SOURCE,
      source: sourceId,
    })

    return removeBlacklistSource(sourceId)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: UNBLACKLIST_SOURCE_FAILURE,
          source: sourceId,
          error,
        })
      })
  }
}


export function subscribeSource(sourceId) {
  return (dispatch) => {
    dispatch({
      type: SUBSCRIBE_SOURCE,
      source: sourceId,
    })

    return addSubscribeSource(sourceId)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: SUBSCRIBE_SOURCE_FAILURE,
          source: sourceId,
          error,
        })
      })
  }
}

export function unSubscribeSource(sourceId) {
  return (dispatch) => {
    dispatch({
      type: UNSUBSCRIBE_SOURCE,
      source: sourceId,
    })

    return removeSubscribeSource(sourceId)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: UNSUBSCRIBE_SOURCE_FAILURE,
          source: sourceId,
          error,
        })
      })
  }
}


export function toggleOverlay(toggleState) {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_OVERLAY_OPEN,
      toggleState,
    })
  }
}

/**
 * @param {number} categoryId
 * @returns {(dispatch: Function, getState: Function) => Promise<void>}
 */
export function whitelistCategory(categoryId) {
  return async (dispatch, getState) => {
    if (!categoryId || isNaN(categoryId)) throw new TypeError(`Invalid category id: ${categoryId}`)

    if (!selectIsUserLoggedIn(getState())) {
      dispatch(genericNotification('Kirjaudu sisään, jotta voit seurata kategorioita', 'info', 'anon-cat-wl'))
      return
    }

    try {
      dispatch({ type: WHITELIST_CATEGORY, id: categoryId })
      const response = await addWhitelistCategory(categoryId)
      dispatch(setUserProfile(response.data.profile))
    } catch (error) {
      logException(error)
      dispatch({
        type: WHITELIST_CATEGORY_FAILURE,
        id: categoryId,
        error,
      })
    }
  }
}

/**
 * @param {number} categoryId
 * @returns {(dispatch: Function, getState: Function) => Promise<void>}
 */
export function unwhitelistCategory(categoryId) {
  return async (dispatch, getState) => {
    if (!categoryId || isNaN(categoryId)) throw new TypeError(`Invalid category id: ${categoryId}`)
    if (!selectIsUserLoggedIn(getState())) return

    try {
      dispatch({ type: UNWHITELIST_CATEGORY, id: categoryId })
      const response = await removeWhitelistCategory(categoryId)
      dispatch(setUserProfile(response.data.profile))
    } catch (error) {
      logException(error)
      dispatch({
        type: UNWHITELIST_CATEGORY_FAILURE,
        id: categoryId,
        error,
      })
    }
  }
}

/**
 * @param {number} categoryId
 * @returns {(dispatch: Function, getState: Function) => Promise<void>}
 */
export function blacklistCategory(categoryId) {
  return async (dispatch, getState) => {
    if (!categoryId || isNaN(categoryId)) throw new TypeError(`Invalid category id: ${categoryId}`)

    if (!selectIsUserLoggedIn(getState())) {
      dispatch(genericNotification('Kirjaudu sisään, jotta voit piilottaa kategorioita', 'info', 'anon-cat-bl'))
      return
    }

    try {
      dispatch({ type: BLACKLIST_CATEGORY, id: categoryId })
      const response = await addBlacklistCategory(categoryId)
      dispatch(setUserProfile(response.data.profile))
    } catch (error) {
      logException(error)
      dispatch({
        type: BLACKLIST_CATEGORY_FAILURE,
        id: categoryId,
        error,
      })
    }
  }
}

/**
 * @param {number} categoryId
 * @returns {(dispatch: Function, getState: Function) => Promise<void>}
 */
export function unblacklistCategory(categoryId) {
  return async (dispatch, getState) => {
    if (!categoryId || isNaN(categoryId)) throw new TypeError(`Invalid category id: ${categoryId}`)
    if (!selectIsUserLoggedIn(getState())) return

    try {
      dispatch({ type: UNBLACKLIST_CATEGORY, id: categoryId })
      const response = await removeBlacklistCategory(categoryId)
      dispatch(setUserProfile(response.data.profile))
    } catch (error) {
      logException(error)
      dispatch({
        type: UNBLACKLIST_CATEGORY_FAILURE,
        id: categoryId,
        error,
      })
    }
  }
}


export function changeVoteFilter(threshold) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_VOTE_FILTER,
      threshold,
    })

    return setUserVoteFilter(threshold)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
        dispatch({type: SET_VOTE_FILTER_SUCCESS, threshold})
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: SET_VOTE_FILTER_FAILURE,
          error,
        })
      })
  }
}


export function addFeed(url) {
  return (dispatch) => {

    dispatch({
      type: ADD_CUSTOM_FEED,
      url,
    })

    return addUserFeed(url)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
        dispatch({type: ADD_CUSTOM_FEED_SUCCESS, url, response})
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: ADD_CUSTOM_FEED_FAILURE,
          url,
          error,
        })
      })
  }
}

export function updateFeed(feedId, categoryId) {
  return (dispatch) => {

    dispatch({
      type: UPDATE_CUSTOM_FEED,
      feedId,
      categoryId,
    })

    return updateUserFeed(feedId, categoryId)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: UPDATE_CUSTOM_FEED_FAILURE,
          feedId,
          categoryId,
          error,
        })
      })
  }
}

export function removeFeed(feedId) {
  return (dispatch) => {

    dispatch({
      type: REMOVE_CUSTOM_FEED,
      feedId,
    })

    return removeUserFeed(feedId)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: REMOVE_CUSTOM_FEED_FAILURE,
          feedId,
          error,
        })
      })
  }
}


export function addWordFilter(filter) {
  return (dispatch) => {
    dispatch({
      type: ADD_USER_WORD_FILTER,
      filter,
    })

    return addUserWordFilter(filter)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        if (error.response && error.response.status === 429) {
          dispatch({
            type: ADD_USER_WORD_FILTER_MAX,
            filter,
            error,
          })
        } else {
          logException(error)
          dispatch({
            type: ADD_USER_WORD_FILTER_FAILURE,
            filter,
            error,
          })
        }
      })
  }
}

export function removeWordFilter(filter) {
  return (dispatch) => {

    dispatch({
      type: REMOVE_USER_WORD_FILTER,
      filter,
    })

    return removeUserWordFilter(filter)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: REMOVE_USER_WORD_FILTER_FAILURE,
          filter,
          error,
        })
      })
  }
}

export function addSavedSearch(searchTerm) {
  return (dispatch) => {
    dispatch({
      type: ADD_USER_SAVED_SEARCH,
      searchTerm,
    })

    return addUserSavedSearch(searchTerm)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
        dispatch({type: ADD_USER_SAVED_SEARCH_SUCCESS, searchTerm})
      })
      .catch(error => {
        if (error.response && error.response.status === 429) {
          dispatch({
            type: ADD_USER_SAVED_SEARCH_MAX,
            searchTerm,
            error,
          })
        } else {
          logException(error)
          dispatch({
            type: ADD_USER_SAVED_SEARCH_FAILURE,
            searchTerm,
            error,
          })
        }
      })
  }
}

export function removeSavedSearch(searchTerm) {
  return (dispatch) => {
    dispatch({
      type: REMOVE_USER_SAVED_SEARCH,
      searchTerm,
    })

    return removeUserSavedSearch(searchTerm)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
        dispatch({type: REMOVE_USER_SAVED_SEARCH_SUCCESS, searchTerm})
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: REMOVE_USER_SAVED_SEARCH_FAILURE,
          searchTerm,
          error,
        })
      })
  }
}

/**
 * @param {number} tagId
 * @returns {(dispatch: Function, getState: Function) => Promise<void>}
 */
export function whitelistTag(tagId) {
  return async (dispatch, getState) => {
    if (!tagId || isNaN(tagId)) throw new TypeError(`Invalid tag id: ${tagId}`)

    if (!selectIsUserLoggedIn(getState())) {
      dispatch(genericNotification('Kirjaudu sisään, jotta voit seurata aihetunnisteita', 'info', 'anon-tag-wl'))
      return
    }

    try {
      dispatch({ type: WHITELIST_TAG, tag: tagId })
      const response = await addWhitelistTag(tagId)
      dispatch(setUserProfile(response.data.profile))
    } catch (error) {
      logException(error)
      dispatch({
        type: WHITELIST_TAG_FAILURE,
        tag: tagId,
        error,
      })
    }
  }
}

/**
 * @param {number} tagId
 * @returns {(dispatch: Function, getState: Function) => Promise<void>}
 */
export function unwhitelistTag(tagId) {
  return async (dispatch, getState) => {
    if (!tagId || isNaN(tagId)) throw new TypeError(`Invalid tag id: ${tagId}`)
    if (!selectIsUserLoggedIn(getState())) return

    try {
      dispatch({ type: UNWHITELIST_TAG, tag: tagId })
      const response = await removeWhitelistTag(tagId)
      dispatch(setUserProfile(response.data.profile))
    } catch (error) {
      logException(error)
      dispatch({
        type: UNWHITELIST_TAG_FAILURE,
        tag: tagId,
        error,
      })
    }
  }
}

/**
 * @param {number} tagId
 * @returns {(dispatch: Function, getState: Function) => Promise<void>}
 */
export function blacklistTag(tagId) {
  return async (dispatch, getState) => {
    if (!tagId || isNaN(tagId)) throw new TypeError(`Invalid tag id: ${tagId}`)

    if (!selectIsUserLoggedIn(getState())) {
      dispatch(genericNotification('Kirjaudu sisään, jotta voit piilottaa aihetunnisteita', 'info', 'anon-tag-bl'))
      return
    }

    try {
      dispatch({ type: BLACKLIST_TAG, tag: tagId })
      const response = await addBlacklistTag(tagId)
      dispatch(setUserProfile(response.data.profile))
    } catch (error) {
      logException(error)
      dispatch({
        type: BLACKLIST_TAG_FAILURE,
        tag: tagId,
        error,
      })
    }
  }
}

/**
 * @param {number} tagId
 * @returns {(dispatch: Function, getState: Function) => Promise<void>}
 */
export function unblacklistTag(tagId) {
  return async (dispatch, getState) => {
    if (!tagId || isNaN(tagId)) throw new TypeError(`Invalid tag id: ${tagId}`)
    if (!selectIsUserLoggedIn(getState())) return

    try {
      dispatch({ type: UNBLACKLIST_TAG, tag: tagId })
      const response = await removeBlacklistTag(tagId)
      dispatch(setUserProfile(response.data.profile))
    } catch (error) {
      logException(error)
      dispatch({
        type: UNBLACKLIST_TAG_FAILURE,
        tag: tagId,
        error,
      })
    }
  }
}


/**
 * Refresh react router by pushing the current location - or if the user is on root page, to their
 * profile's preferred front page. This is important to update @provideHook's fetch so all user
 * relevant data/logic gets updated.
 */
export function afterLoginRefresh() {
  return (dispatch, getState) => {
    const state = getState()
    const currentLocation = selectLocationPath(state)
    const currentStatus = selectLocationStatus(state)
    const profileFrontPage = selectUserFrontPage(state)

    if (currentLocation === '/' || currentStatus !== 200) {
      dispatch(push(profileFrontPage || '/'))
    } else {
      dispatch(push(currentLocation))
    }
  }
}

export function setUserProfile(profile) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_ACTIVE_USER_PROFILE,
      profile,
      timestamp: Date.now(),
    })

    if (canUseDOM) {
      setThemeBodyClass(selectUserActiveTheme(getState()))
      setLayoutWidthBodyClass(selectUserLayoutWidth(getState()))
    }
  }
}




export function setLoggedInUser(id, name, email, userHash, almaIdHash, jwt) {
  return dispatch => {
    dispatch({
      type: SET_LOGGED_IN_USER,
      username: name,
      userId: id,
      userHash,
      almaIdHash,
      email,
      jwt,
    })
  }
}


/**
 * Initialize user and profile data from cookies. For logged in users this means
 * fetching data using the JWT cookie and persisting a hash-derived A/B test
 * bucket to cookie so it survives future logouts. For logged out users this
 * means reading the tempProfile cookie and assigning a sticky anonymous A/B
 * test bucket from the persisted cookie (or a fresh random one if none).
 *
 * SSR-only: on the client the state is rehydrated from `__INITIAL_STATE__`
 * and this function should not run.
 *
 * @returns {(dispatch: Function, getState: Function) => Promise<void>}
 */
export function initUser(cookies) {
  return async (dispatch, getState) => {
    if (canUseDOM) {
      logWarning('initUser called on the client, ignoring. initUser is SSR-only.')
      return
    }

    const userCookie = cookies.get(AMPPARIT_USER_COOKIE_NAME)
    const jwt = (typeof userCookie === 'string' && userCookie.match(/^eyJ/))
      ? userCookie
      : null

    if (!jwt) { // Init nightmode and A/B test bucket from cookies if user is not logged in
      const tempProfile = getTempProfile(cookies)
      dispatch(setTempProfile(cookies, tempProfile))
      dispatch(setAbTestBucket(getOrCreateAbBucket(cookies)))
      return
    }

    // User cookie is httpOnly, default config.cookieOptions is not. Since initUser()
    // only runs in server side rendering we are able to set or remove it here.
    const userCookieOptions = Object.assign({}, config.cookieOptions, { httpOnly: true })

    try {
      const response = await getUser(jwt)
      const { id, name, email, profile, userHash, almaIdHash } = response.data
      dispatch(setLoggedInUser(id, name, email, userHash, almaIdHash, jwt))
      dispatch(setAbTestBucket(getOrCreateAbBucket(cookies, almaIdHash)))
      dispatch(setUserProfile(profile))
      cookies.set(AMPPARIT_USER_COOKIE_NAME, jwt, userCookieOptions)
    } catch (error) {
      if (error.response && error.response.status === 401) {
        cookies.remove(AMPPARIT_USER_COOKIE_NAME, userCookieOptions)
      } else {
        logException(error)
      }
    }
  }
}


export function logoutAmpparit() {
  return async (dispatch) => {
    dispatch({
      type: LOGOUT_USER,
    })

    try {
      await logoutAmpparitUser()
      dispatch({
        type: LOGOUT_USER_SUCCESS,
      })
      // We could reset profile data here, but since Ampparit logout is always followed by AlmaTunnus logout,
      // we don't need to. Alma logout will trigger a hard reload of the page, resetting all state.
    } catch (error) {
      logException(error)
      dispatch({
        type: LOGOUT_USER_FAILURE,
        error,
      })
    }
  }
}

export function addUserWeatherLocation(locationId) {
  return (dispatch, getState) => {

    dispatch({
      type: ADD_WEATHER_LOCATION,
    })

    return addWeatherLocation(locationId)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: ADD_WEATHER_LOCATION_FAILURE,
          error,
        })
      })
  }
}

export function removeUserWeatherLocation(locationId) {
  return (dispatch, getState) => {

    dispatch({
      type: REMOVE_WEATHER_LOCATION,
    })

    return removeWeatherLocation(locationId)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: REMOVE_WEATHER_LOCATION_FAILURE,
          error,
        })
      })
  }
}


export function setUserDefaultWeatherLocation(locationId) {
  return (dispatch, getState) => {

    dispatch({
      type: SET_DEFAULT_WEATHER_LOCATION,
      locationId,
    })

    return setDefaultWeatherLocation(locationId)
      .then(response => {
        dispatch(setUserProfile(response.data.profile))
      })
      .catch(error => {
        logException(error)
        dispatch({
          type: SET_DEFAULT_WEATHER_LOCATION_FAILURE,
          error,
        })
      })
  }
}


export function setAbTestBucket(bucket) {
  if (!Number.isInteger(bucket) || bucket < 0 || bucket > 99) {
    throw new TypeError(`Invalid bucket number: ${bucket}. Must be between 0 and 99.`)
  }
  return { type: SET_AB_TEST_BUCKET, bucket}
}



/**
 * DO NOT USE UNTIL getItems() IN api.js HAS BEEN CHANGED TO NOT
 * DEPEND ON JWT FOR CHOOSING BETWEEN CACHEABLE AND NON-CACHEABLE
 * ENDPOINTS.
 *
 * Clears user JWT from redux store after server side rendering but
 * before state serialization. This way the JWT will only exists on
 * the client as HttpOnly cookie, meaning it cannot possibly be stolen
 * even if someone manages to inject malicious code.
 */
export function clearUserJWT() {
  return { type: CLEAR_USER_JWT }
}
